import React from "react";
import { FlyerDetailPageFormPositionProductsTableImageProps } from "./flyer-detail-page-form-position-products-table-image.props";
import { ProductBoxImage } from "./flyer-detail-page-form-position-products-table-image.styles";

export const FlyerDetailPageFormPositionProductsTableImage = (
  props: FlyerDetailPageFormPositionProductsTableImageProps
) => {
  if (!props.imageUrl || !props.imageUrl.length) {
    return <div />;
  }

  return <ProductBoxImage src={props.imageUrl} alt="product image" />;
};
